import React, { useState } from 'react';
import { MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBCheckbox } from 'mdb-react-ui-kit';

const Chamber = ({ userSelectedChambers, setUserSelectedChamber }) => {
    const [collapse, setCollapse] = useState(false);
    const chambers = [
        { id: 'HOUSE', label: 'House' },
        { id: 'SENATE', label: 'Senate' }
    ];

    const handleChamberChange = (chamberId) => {
        setUserSelectedChamber(prev => {
            if (prev.includes(chamberId)) {
                return prev.filter(id => id !== chamberId);
            } else {
                return [...prev, chamberId];
            }
        });
    };

    return (
        <MDBSideNavItem>
            <MDBSideNavLink icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                Chamber
            </MDBSideNavLink>
            <MDBSideNavCollapse open={collapse}>
                <li className="p-3">
                    {chambers.map(chamber => (
                        <MDBCheckbox
                            key={chamber.id}
                            name={chamber.id}
                            id={chamber.id}
                            label={chamber.label}
                            checked={ userSelectedChambers && userSelectedChambers.includes(chamber.id)}
                            onChange={() => handleChamberChange(chamber.id)}
                        />
                    ))}
                </li>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default Chamber;
